export enum OrderType {
  Urgent = 1,
  Unplanned = 2,
  Planned = 3,
  Unbound = 4,
  AnyType = 5
}
